export const sidebar_lg = '260px';
export const sidebar_md = '120px';
export const sidebar_xs = ''